import { ErrorStatePageError } from 'ui/illustrations';
import { AlternativeState } from './AlternativeStateTemplate';

export const ErrorStateCopy = {
  title: 'We’ve ran into a snag!',
  subtitle:
    'There was an error loading the snippet data. Please try refreshing the page or wait a few minutes and try again.',
};
export const ErrorState = () => (
  <AlternativeState
    Illustration={ErrorStatePageError}
    title={ErrorStateCopy.title}
    subtitle={ErrorStateCopy.subtitle}
    showRefreshBtn
  />
);
